import { createSlice } from "@reduxjs/toolkit";
import { deleteCampaign, duplicateCampaign, getCampaigns, getDetailCampaign, updateCampaign, updateStatusCampaign } from "./thunk";

export const initialState = {
  campaigns: [],
  campaignDetail: {},
  errors: null,
  loading: false,
}

const CampaignSlice = createSlice({
  name: 'Campaign',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCampaigns.fulfilled, (state: any, action: any) => {
      state.campaigns = action.payload;
      state.loading = false;
    });
    builder.addCase(getCampaigns.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(getCampaigns.pending, (state: any) => {
      state.loading = true;
    })

    builder.addCase(updateStatusCampaign.fulfilled, (state: any, action: any) => {
      state.campaigns = [...state.campaigns, action.payload];
    });
    builder.addCase(updateStatusCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(updateStatusCampaign.pending, (state: any) => {
    })

    //
    builder.addCase(updateCampaign.fulfilled, (state: any, action: any) => {
      state.campaigns = state.campaigns.map((list: any) =>
        list.id === action.payload.id
          ? { ...list, ...action.payload }
          : list
      );

      state.error = null;
    });
    builder.addCase(updateCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(updateCampaign.pending, (state: any) => {
    })

    builder.addCase(getDetailCampaign.fulfilled, (state: any, action: any) => {
      state.campaignDetail = action.payload;
    });
    builder.addCase(getDetailCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(getDetailCampaign.pending, (state: any) => {
    })

    builder.addCase(deleteCampaign.fulfilled, (state: any, action: any) => {
      state.campaigns = state.campaigns.filter((campaign: any) => campaign.id !== action?.payload);
    });
    builder.addCase(deleteCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(deleteCampaign.pending, (state: any) => {
    })

    builder.addCase(duplicateCampaign.fulfilled, (state: any, action: any) => {
      state.campaigns = [...state.campaigns, action.payload];
    });
    builder.addCase(duplicateCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(duplicateCampaign.pending, (state: any) => {
    })
  },
});

export default CampaignSlice.reducer;
